import { createValidator, maxLength, required } from 'util/validation'

import { ConfiguracaoAnexoArquivosModel } from './model-anexoArquivos'

export const validate = createValidator<ConfiguracaoAnexoArquivosModel>({
  diretorio: [required, maxLength(255)],
})
